import { render, staticRenderFns } from "./form-details.vue?vue&type=template&id=66a6e773&scoped=true"
import script from "./form-details.vue?vue&type=script&lang=js"
export * from "./form-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a6e773",
  null
  
)

export default component.exports